/*********************** Custom JS for Boost AI Search & Discovery  ************************/

// Spacing Issue Regex Start
var regex = /(\S+)\(/g;
var regex2 = /(\d+)/g;

var observer = new MutationObserver(function(mutationsList, observer) {
  mutationsList.forEach(function(mutation) {
    var addedNodes = mutation.addedNodes;
    addedNodes.forEach(function(node) {
      if (node && node.id == "boost-sd__filter-tree-wrapper") {
        let els = node.querySelectorAll('.boost-sd__filter-option-item')
        console.log(els)
        els.forEach(item => {
          let currentElement = item.querySelector('.boost-sd__filter-option-item-label');
          let str = currentElement.textContent.toLowerCase();
          currentElement.textContent = str.charAt(0).toUpperCase() + str.slice(1);
          currentElement.textContent = currentElement.textContent.replace(regex2, ' $1');
          currentElement.textContent = currentElement.textContent.replace(regex, '$1 (');
          currentElement.textContent = currentElement.textContent.replace(/\(\s+/g, '(')
          currentElement.textContent = currentElement.textContent.replace(/-/g, " - ");
        })
      }
    });
  });
});

var targetNode = document.getElementById('main');
observer.observe(targetNode, {
  childList: true,
  subtree: true
});

// Spacing Issue Regex End